import { Result, Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";

const Home = () => {
    const [setting, setSetting] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const iframeRef = useRef<any>(null);

    const refShortCutsSetting = useRef<any>(null);
    const refCommonReportSetting = useRef<any>(null);

    useEffect(() => {
        onLoad();
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [])

    const onLoad = () => {
        // setSetting([
        //     // { id: '1', span: 1, height: 0, url: '/deskpart/foundation/ShortCuts' },
        //     // { id: '2', span: 2, height: 420, url: '/deskpart/foundation/RecentMessage' },
        //     // { id: '3', span: 2, height: 420, url: '/deskpart/foundation/commonreport' },
        //     { id: '3', span: 1, height: 0, url: '/deskpart/gltms/ordercount' },
        //     { id: '4', span: 4, height: 218, url: '/deskpart/gltms/takingplanrate' },
        //     { id: '4', span: 4, height: 218, url: '/deskpart/gltms/takingloadrate' },
        //     { id: '4', span: 4, height: 218, url: '/deskpart/gltms/loadingplanrate' },
        //     { id: '4', span: 4, height: 218, url: '/deskpart/gltms/loadingloadrate' },
        //     // { id: '1', span: 1, height: 400, url: '/deskpart/gltms/loadsummary' },
        //     // { id: '2', span: 2, height: 400, url: '/deskpart/gltms/factorycarrierordersummary' },
        //     // { id: '2', span: 2, height: 400, url: '/deskpart/gltms/vendorordersummary' },
        //     // { id: '2', span: 2, height: 400, url: '/deskpart/gltms/factoryordersummary' },
        //     // { id: '2', span: 2, height: 400, url: '/deskpart/gltms/carrierordersummary' },
        //     { id: '5', span: 1, height: 400, url: '/deskpart/foundation/LoginCountReport' }
        //     // { id: '4', span: 2, height: 218, url: '/deskpart/gltms/loaddetailsummary' },
        //     // { id: '5', span: 3, height: 420, url: '/deskpart/foundation/RecentMessage' },
        //     // { id: '6', span: 3, height: 420, url: '/deskpart/foundation/RecentMessage' },
        //     // { id: '7', span: 3, height: 420, url: '/deskpart/foundation/RecentMessage' },
        // ]);
        setSetting([
            { id: '1', span: 1, height: 0, url: '/deskpart/yearordercount' },
            { id: '5', span: 2, height: 420, url: '/deskpart/yearordecompanyreport' },
            { id: '5', span: 2, height: 420, url: '/deskpart/yearordesalesreport' },
            { id: '6', span: 1, height: 400, url: '/deskpart/yearorderreport' }
        ]);
        setLoading(false);
    }

    const handleMessage = (event: MessageEvent) => {
        switch (event.data) {
            case "ShortCutsSetting":
                refShortCutsSetting.current.setVisible(true);
                break;
            case "CommonReportSetting":
                refCommonReportSetting.current.setVisible(true);
                break;
        }
    }

    const onLoadShortCuts = () => {
        if (iframeRef.current) {
            iframeRef.current?.contentWindow.postMessage({ data: 'ShortCuts' }, '*');
            // console.log('调用：onLoadShortCuts')
        }
    }

    return <div style={{ height: '100%', overflow: 'scroll' }}>
        <Skeleton loading={loading} active >{setting ? (setting ?? []).map((item: any) => {
            if (item.span == 1) {
                return <iframe id={item.id} src={item.url}
                    style={{
                        width: 'calc(100% - 4px)',
                        border: '1px solid #e7e7eb',
                        minHeight: 102,
                        height: item.height > 0 ? item.height : 'auto',
                        margin: '0px 2px 0px 2px'
                    }} ref={iframeRef} />
            } else if (item.span == 3) {
                return <iframe id={item.id} src={item.url} style={{
                    float: 'left',
                    width: 'calc(33% - 4px)',
                    border: '1px solid #e7e7eb',
                    minHeight: 102,
                    height: item.height > 0 ? item.height : 'auto',
                    margin: '0px 2px 2px 2px'
                }} ref={iframeRef} />
            } else if (item.span == 4) {
                return <iframe id={item.id} src={item.url} style={{
                    float: 'left',
                    width: 'calc(25% - 4px)',
                    border: '1px solid #e7e7eb',
                    minHeight: 102,
                    height: item.height > 0 ? item.height : 'auto',
                    margin: '0px 2px 2px 2px',
                }} ref={iframeRef} />
            }
            else {
                return <iframe id={item.id} src={item.url} style={{
                    float: 'left',
                    width: 'calc(50% - 4px)',
                    border: '1px solid #e7e7eb',
                    minHeight: 102,
                    height: item.height > 0 ? item.height : 'auto',
                    margin: '0px 1px 2px 2px'
                }} ref={iframeRef} />
            }
        }) :
            <div style={{ background: 'whitesmoke', width: '100%', height: '100%' }}>
                <Result
                    status='info'
                    title="该用户角色尚未设置首页部件"
                    subTitle="请联系管理员设置首页部件后，首页内容即可展示."
                    extra={<></>}
                />
            </div>
        }</Skeleton>
    </div >
}
export default Home;